import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20abstract%20composition%20with%20soft%20coral%20and%20deep%20crimson%20gradients%2C%20flowing%20organic%20shapes%2C%20luxurious%20theater-like%20atmosphere%2C%20subtle%20particles%20of%20light%2C%20elegant%20and%20sophisticated%20entertainment%20brand%20aesthetic%2C%20clean%20minimalist%20background%20with%20rich%20warm%20tones&width=1800&height=700&seq=cta-bg-bottom&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/70" />

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3">
          准备好开启<span className="text-primary-400">极致观影</span>之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/65 mb-8 max-w-lg mx-auto leading-relaxed">
          加入红桃视频，畅享5000万用户信赖的高清影视平台，海量正版内容等你发现
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/tv-series"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            立即开始观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}